<template>

  <PageHeader
    title="Care Management Configuration"
    subtitle="Configure care plan domains, module templates, and management settings"
    :breadcrumbs="[{ label: 'Admin Console' }]"
  >
    <template #bottom>
      <Page_Tabs
        class="px-6 pt-4"
        :tabs="tabLabels"
        :initial-tab="activeTabLabel"
        no-border
        @select="handleTabSelect"
      />
    </template>
  </PageHeader>

  <div class="care-management-admin p-4">
    <!-- Tab Content -->
    <div class="bg-white rounded-lg border border-gray-200">
      <CarePlan_Admin v-if="activeTab === 'care-plan-domains'" />
      <SurveyQuestions_Admin v-if="activeTab === 'survey-questions'" />
      <ClinicalSummaryTemplate_Admin v-if="activeTab === 'clinical-summaries'" @show-message="showMessage" />
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import CarePlan_Admin from './Widgets/Care_Plan/CarePlan_Admin.vue';
import SurveyQuestions_Admin from '@/components/Care_Management/Admin/SurveyQuestionsAdmin.vue';
import ClinicalSummaryTemplate_Admin from './Widgets/Clinical_History/ClinicalSummaryTemplate_Admin.vue';
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue';

export default {
  name: 'CareManagement_Admin',

  components: {
    FontAwesomeIcon,
    CarePlan_Admin,
    SurveyQuestions_Admin,
    ClinicalSummaryTemplate_Admin,
    PageHeader,
    Page_Tabs
  },

  data() {
    return {
      activeTab: 'care-plan-domains',
      tabs: [
        {
          key: 'care-plan-domains',
          label: 'Care Plan Domains',
          icon: ['fas', 'layer-group'],
          description: 'Configure care plan domains and their module templates. Domains represent high-level categories like Physical Health, Mental Health, and Functional Status.'
        },
        {
          key: 'survey-questions',
          label: 'Survey Questions',
          icon: ['fas', 'circle-question'],
          description: 'Manage survey questions, instruments, and their relationships. Create reusable questions that can be dynamically assembled into surveys.'
        },
        {
          key: 'clinical-summaries',
          label: 'Clinical Summaries',
          icon: ['fas', 'file-lines'],
          description: 'Configure AI-powered clinical summary templates for Rx and Dx data. Define the LLM prompts and output schemas for generating intelligent summaries.'
        }
      ]
    };
  },

  computed: {
    tabLabels() {
      return this.tabs.map(t => t.label);
    },
    activeTabLabel() {
      const tab = this.tabs.find(t => t.key === this.activeTab);
      return tab ? tab.label : this.tabs[0].label;
    }
  },

  methods: {
    handleTabSelect(label) {
      const tab = this.tabs.find(t => t.label === label);
      if (tab) this.activeTab = tab.key;
    },

    showMessage(message, type) {
      this.$emit('show-message', message, type);
    }
  }
};
</script>
